import {
  DataImportantStatusEnum,
  ENUM_USER_SHIPPING_STATUS,
  ENUM_USER_STATUS,
} from "../../user/types";
import { IData, RetailerState } from "../types";

export const defaultFormData: IData = {
  _id: "",
  firstName: "",
  lastName: "",
  japaneseFirstName: "",
  japaneseLastName: "",
  email: "",
  status: ENUM_USER_STATUS.ACTIVE,
  createdAt: "",
  updatedAt: "",
  mobileNumber: "",
  password: "",
  confirmPassword: "",
  streetAddress: "",
  postCode: "",
  prefectures: "",
  companyName: "",
  importantStatus: DataImportantStatusEnum.Null,
  customerId: "",
  shippingFreeStatus: ENUM_USER_SHIPPING_STATUS.NO,
};

export const initialState: RetailerState = {
  formData: { ...defaultFormData },
  list: [],
  loading: false,
  buttonLoading: false,
  toggleLoading: false,
  search: "",
  pageNo: 1,
  pageSize: 30,
  totalRow: 0,
  orderBy: "",
  orderDir: "",
  orders: [],
  orderPageNo: 1,
  orderPageSize: 30,
  orderTotalRow: 0,
  endDate: null,
  startDate: null,
};
